import { render, staticRenderFns } from "./ownerTaskHis.vue?vue&type=template&id=0cc023f3&scoped=true"
import script from "./ownerTaskHis.vue?vue&type=script&lang=js"
export * from "./ownerTaskHis.vue?vue&type=script&lang=js"
import style0 from "./ownerTaskHis.vue?vue&type=style&index=0&id=0cc023f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc023f3",
  null
  
)

export default component.exports